export default __webpack_public_path__ + "static/moc-1-1-1479dafaa545b262bf4b5530b0d90bf5.png";